import React from 'react';
import { useTranslation } from 'react-i18next';
import agradecimento from '../images/agradecimento.gif';
import Header from '../components/Header';

export function Agradecimento() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div className="shrink-0">
        <Header
          langSwitcher
          contatos={t('nav.contatos')}
          homePage={t('nav.homePage')}
          tecnologias={t('nav.tecnologias')}
        />
      </div>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center overflow-hidden bg-gray-800 px-3 py-2 sm:px-4">
        <img
          className="h-auto max-h-full w-auto max-w-full object-contain"
          src={agradecimento}
          alt="gif de agradecimento"
        />
      </div>
    </div>
  );
}

export default Agradecimento;
